import i18n from "i18next";
import { formatNumber } from "../utils/formatNumber";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/it";

import enTranslation from "./locales/en.json";
import itTranslation from "./locales/it.json";

const normalizeLang = (lng: string | undefined): string => {
  if (!lng) return "en";
  const code = lng.toLowerCase().split(/[-_]/)[0];
  if (code && ["en", "it", "fr", "de", "es"].includes(code)) return code;
  return "en";
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      it: { translation: itTranslation },
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    // detection: {
    //   order: ["localStorage", "navigator"],
    //   caches: ["localStorage"],
    // },
  });

i18n.services.formatter?.add("quantity", (value, language) => {
  const displayed = formatNumber(value, language);
  return displayed === "--" ? value : displayed;
});

const normalizedInitial = normalizeLang(i18n.language);

if (i18n.language !== normalizedInitial) {
  i18n.changeLanguage(normalizedInitial);
  localStorage.setItem("i18nextLng", normalizedInitial);
}

dayjs.locale(normalizedInitial);

i18n.on("languageChanged", (lng: string) => {
  const normalized = normalizeLang(lng);
  if (lng !== normalized) {
    i18n.changeLanguage(normalized);
  }
  localStorage.setItem("i18nextLng", normalized);
  dayjs.locale(normalized);
});

export default i18n;
